export default "__VITE_ASSET__09987594__"